import { ApiKeyFetch } from 'api/fetchers/apiKey';
import Button from 'components/Buttons/Button';
import { urlCancelarTokensCorreo } from 'constants/urls';
import { useAccionesPantallaPago, usePantallaPago } from 'contexts/FormPagoContext';
import useCustomToast from 'hooks/useCustomToasts';
import useUsuario from 'hooks/useUsuario';
import React from 'react';

/**
 * Componente para cancelar el token de correo.
 *
 * Este componente permite al usuario cancelar un token de correo previamente enviado
 * para realizar el pago.
 */
const CancelarTokenCorreo = () => {
  const state = usePantallaPago();
  const usuario = useUsuario();
  const acciones = useAccionesPantallaPago();
  const toasts = useCustomToast();

  /**
   * Manejador del evento click para cancelar el token.
   *
   * Realiza una solicitud para cancelar el token de correo y muestra
   * mensajes de éxito o advertencia según la respuesta.
   */
  const onClickCancelarToken = async () => {
    acciones.cancelarTokenCorreo(true);

    const payload = {
      idPoliza: state.idPoliza,
      codProducto: state.codProducto,
      idUsuario: usuario.cliCodigoCore,
    };

    const response = await ApiKeyFetch.instance().post(urlCancelarTokensCorreo, payload);

    if (response.transaccion) {
      acciones.setState({
        showFormPago: true,
        showFormCancelarTokens: false,
        isCancelandoToken: false,
      });
      toasts.addSuccessToast('Se ha desactivado todos los correos de pago activos');
      return;
    }

    if (response?.transaccion === false) {
      if (response?.errorMessage) {
        toasts.addWarningToast(response?.errorMessage);
      }
      reloadPageWithDelay();
      return;
    }

    reloadPageWithDelay();
    toasts.addWarningToast('Ha ocurrido un problema al procesar tu solicitud');
  };

  /**
   * Recarga la página después de un retraso de 2 segundos.
   */
  const reloadPageWithDelay = () => {
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <React.Fragment>
      <h4 className="font-source-sans-regular font-20px">
        Hemos enviado previamente una liga para realizar el pago, ¿Quieres cancelarla?
      </h4>
      <Button
        className="p-button-primary mt-2 mx-auto px-3"
        type="button"
        onClick={onClickCancelarToken}
        disabled={state.isCancelandoToken}
        label={state.isCancelandoToken ? 'Cancelando correo de pago...' : 'Si, cancelar'}
      />
    </React.Fragment>
  );
};

export default CancelarTokenCorreo;
